import React from 'react';
import { Link } from 'react-router-dom';
import Container, {
  Button,
  Logo,
  LogoContainer,
  Breadcrumbs,
  Point,
} from './styles';
import discord from '../../Assets/Images/discord_nobg.png';
import adopteUnVillageois from '../../Assets/Images/adopte_un_villageois_noBackground.png';
import Socials from './Socials';

const Footer = () => (
  <Container>
    <LogoContainer>
      <Logo src={adopteUnVillageois} alt="logo" />
    </LogoContainer>
    <h3>Retrouvez-nous sur les réseaux</h3>
    <div className="socials__container">
      <Socials />
    </div>
    <Button>
      <img src={discord} alt="logo discord" width="22" height="22px" />
      <span>Rejoindre le Discord</span>
    </Button>
    <Breadcrumbs>
      <ul>
        Aide
        <Point />
        A propos
        <Point />
        <li>Mentions légales</li>
        <Point />
        <li>Confidentialité</li>
      </ul>
    </Breadcrumbs>
    <p>&copy; 2020 Le Perchoir</p>
  </Container>
);

export default Footer;
